import { BASE_URL } from './config';

export async function ensureSession({ force } = {}) {
  if (!force) {
    const hasCSRFToken = document.cookie
      .split('; ')
      .some((cookie) => cookie.startsWith('csrf_token='));

    if (hasCSRFToken) return;
  }

  const response = await fetch(`${BASE_URL}/session/init`, {
    method: 'GET',
    credentials: 'include',
  });

  if (!response.ok) {
    throw new Error('Session initialization failed');
  }
}
